import { useDispatch, useSelector } from 'react-redux'
import { ContactAddressType } from '../common/ContactAddress.type'
import {
  addContactAddress,
  selectAllContacts,
} from '../slices/contactAddressSlice'
import useNavigatePrevPage from './useNavigatePrevPage'

const useCreateContact = () => {
  const maxID = (contactAddresses: ContactAddressType[]) =>
    contactAddresses.length ? contactAddresses.slice(-1)[0].id + 1 : 0
  const allContactAddresses = useSelector(selectAllContacts)
  const dispatch = useDispatch()

  const addContact = (contactAddress: Omit<ContactAddressType, 'id'>) => {
    const newContactAddress: ContactAddressType = {
      ...contactAddress,
      id: maxID(allContactAddresses),
    }

    dispatch(addContactAddress(newContactAddress))
  }

  const { navigatePrevPage } = useNavigatePrevPage()

  return { addContact, navigatePrevPage }
}

export default useCreateContact
